import React, { useEffect, useState } from "react";
import api, { fileUrl } from "@/lib/apiClient";
import SEO from "@/components/SEO";

function Avatar({ leader, large }) {
  const size = large ? "w-40 h-40" : "w-24 h-24";
  if (leader.photo_path) {
    return <img src={fileUrl(leader.photo_path)} alt={leader.name} className={`${size} rounded-sm object-cover border border-npst-gold/30 shrink-0`} />;
  }
  return (
    <div className={`${size} rounded-sm bg-npst-navy text-npst-goldLight flex items-center justify-center font-display font-bold ${large ? "text-4xl" : "text-2xl"} border border-npst-gold/30 shrink-0`}>
      {leader.name?.split(" ").slice(-1)[0]?.[0] || "N"}
    </div>
  );
}

export default function Leadership() {
  const [leaders, setLeaders] = useState([]);
  useEffect(() => { api.get("/leadership").then(({ data }) => setLeaders(data)).catch(() => {}); }, []);
  const chairman = leaders.find((l) => l.is_chairman);
  const others = leaders.filter((l) => !l.is_chairman);

  return (
    <div className="fade-in">
      <SEO title="Leadership — NPST" description="Chairman, trustees and office bearers of the National Public Service Trust." canonical={`${window.location.origin}/leadership`} />
      <section className="border-b border-npst-line paper-texture">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="label-eyebrow text-npst-gold mb-3">Governance</div>
          <h1 className="font-serif text-4xl sm:text-6xl font-semibold text-npst-ink tracking-tight">Chairman & Trustees</h1>
        </div>
      </section>

      {chairman && (
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 border-b border-npst-line">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
            <div className="lg:col-span-3"><Avatar leader={chairman} large /></div>
            <div className="lg:col-span-9">
              <div className="label-eyebrow text-npst-gold mb-2">{chairman.designation}</div>
              <h2 className="font-serif text-4xl text-npst-ink">{chairman.name}</h2>
              {chairman.bio && <p className="mt-5 text-lg text-npst-inkSoft leading-relaxed max-w-3xl">{chairman.bio}</p>}
              {chairman.background && <p className="mt-4 text-npst-inkSoft leading-relaxed max-w-3xl">{chairman.background}</p>}
              {chairman.message && (
                <blockquote className="mt-8 border-l-2 border-npst-gold pl-6 font-serif text-2xl text-npst-navy italic leading-relaxed max-w-3xl">“{chairman.message}”</blockquote>
              )}
            </div>
          </div>
        </section>
      )}

      {others.length > 0 && (
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="label-eyebrow text-npst-gold mb-10">Office Bearers & Trustees</div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
            {others.map((l) => (
              <div key={l.id} className="flex gap-5" data-testid="leader-card">
                <Avatar leader={l} />
                <div>
                  <div className="label-eyebrow text-npst-gold mb-1">{l.designation}</div>
                  <div className="font-serif text-2xl text-npst-ink">{l.name}</div>
                  {l.bio && <p className="text-sm text-npst-inkSoft mt-2 leading-relaxed">{l.bio}</p>}
                </div>
              </div>
            ))}
          </div>
        </section>
      )}
    </div>
  );
}
